// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pic_box":"pic_box-203ye102"};